import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { setSentryUser } from "@blis/telemetry/client";

import { ConfigProvider, fetchConfig } from "@/lib/config";
import { fetchUser, User } from "@/lib/user";

export const Route = createFileRoute("/_auth")({
  beforeLoad: async ({ location }) => {
    const [userRes, config] = await Promise.all([fetchUser(), fetchConfig()]);
    if (!userRes) {
      throw redirect({ to: "/login", search: { next: location.pathname } });
    }
    const user = new User(userRes);
    setSentryUser({ email: user.profile.email, id: user.profile.id });

    return { user, config };
  },
  component: () => {
    const { config } = Route.useRouteContext();
    return (
      <ConfigProvider config={config}>
        <Outlet />
      </ConfigProvider>
    );
  },
});
